export function accumulate(lst) {
  return lst.reduce((acc, item) => [item + acc[0], ...acc], [0]).reverse()
}